import { render } from "./MobileAppPage.vue?vue&type=template&id=3c1d3f4e&scoped=true"
import script from "./MobileAppPage.vue?vue&type=script&lang=js"
export * from "./MobileAppPage.vue?vue&type=script&lang=js"

import "./MobileAppPage.vue?vue&type=style&index=0&id=3c1d3f4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1d3f4e"]])

export default __exports__